var map = {
	"./dingdanshuliang.png": "ca31",
	"./hezuomoshi.png": "d789",
	"./quanpinlei.png": "b2a5",
	"./tuihuanhuo.png": "ce53",
	"./xuankuanhezuo.png": "3a7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd0";